/* eslint-disable array-callback-return */
/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import { emptyValidation } from "../../../../../../helpers/validation";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { customerProductLineHead } from '../../../../../../config/constant';
import { LineForm } from "./LineForm";
import { LineTable } from "./LineTable";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import CustomerProducts from "../../../../Management/components/SelfBills/CustomerProducts";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";

export const LineView = React.forwardRef((props, ref) => {
    const { roleManagement, checkComponentPermission, clsx, classes, handleMyProductsLoad, allLinesData, onRequestSort, sortBy, sortOrder,
        unitMesurementdetails, handleProductPrice, capitalizeFirstLetter, dispatch, customObject, deleteBulkLine, idNamingConversion,
        handleSearch, form, headerView, lineSubmit, lineBulkSubmit, lines, allLines, exportCommonFile, productApi, search } = props;
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [productVisible, setProductVisible] = useState(false);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [title, setTitle] = useState('Add');
    const [lineId, setLineId] = useState('');
    const [view, setView] = useState(false);

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        setLineId('');
        setLineForm({
            status: true,
        });
        setLineError({});
        productApi();
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyProduct = emptyValidation('Product', lineForm?.productId, 'dropDown');
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyQuantity = emptyValidation('Quantity', lineForm?.quantity);

        setLineError({});
        if (emptyProduct.isValid && emptyUnit.isValid && emptyQuantity.isValid) {
            lineForm.quantity = parseInt(lineForm.quantity);
            lineForm.customerId = form?.customerId;
            let a = { ...lineForm };
            a.status = a.status ? 'ACTIVE' : 'INACTIVE';
            lineSubmit(a, lineId);
            handleOpen();
            if (more) {
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else {
            setLineError({
                productId: emptyProduct?.errors || false,
                unitId: emptyUnit?.errors || false,
                quantity: emptyQuantity?.errors || false
            })
        }
    }


    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'unit': e
                });
            } else {
                setLineForm({
                    ...lineForm,
                    [name]: e
                });
            }

        } else {
            setLineForm({
                ...lineForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const onEdit = (data, i, view) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        productApi('', data?.productId);
        let a = { ...data, status: data.status === 'ACTIVE' ? true : false };
        setLineForm(a);
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);
    }

    const handleProductChange = (d) => {
        if (d?.id) {
            let data = {
                productId: d?.id,
                product: d
            }
            data['unitId'] = d?.salesUnitId || '';
            data['unit'] = d?.salesUnit || '';
            setLineForm({ ...lineForm, ...data });
        }
    }


    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        exportCommonFile(name, allLines, data, selected, extension);
    }

    const handleBulkLineSubmit = (selected) => {
        let a = [];
        allLinesData?.length > 0 && allLinesData.map((el) => {
            let index = selected?.findIndex((d, i) => d.productId === el.productId);
            let fIndex = selected?.find((d, i) => d.productId === el.productId);
            if (index >= 0 && fIndex) {
                el.updated = true;
                el.quantity = fIndex.quantity;
                selected.splice(index, 1, el);
            }
        });

        selected?.length > 0 && selected.map((el) => {
            delete el.amount; delete el.cgst; delete el.cgstPercentage; delete el.description; delete el.discountAmount; delete el.discountPercent; delete el.gstAmount; delete el.hsnId; delete el.igst; delete el.igstPercentage; delete el.maxRetailPrice; delete el.pricePerUnit; delete el.productGst; delete el.productGstId; delete el.sgst; delete el.sgstPercentage;
            let values = { ...el, productId: el.productId, customerId: form?.customerId, product: el.product, status: 'ACTIVE', quantity: parseFloat(el.quantity), unitId: el.unitId, unit: el.unit };
            let index = lines?.findIndex((d, i) => d.productId === el.productId);
            if (index >= 0) {
                values.updated = true;
                a.push(values);
            } else {
                a.push(values);
            }
        });

        let deleted = lines?.filter((d, i) => selected.every(e => e.productId !== d.productId));
        deleted?.length > 0 && deleted.map((el) => {
            let index = lines?.findIndex((d, i) => d.productId === el.productId);
            lines.splice(index, 1); deleteBulkLine(el);
            allLines.splice(index, 1);
        });

        lineBulkSubmit(a);
        setProductVisible(false);
    }


    return (
        <>
            <Row>
                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                    {
                        roleManagement !== '' && checkComponentPermission('Customer Products', 'Page', 'Search Line') &&
                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                            <TextField autoComplete='one-time-code'
                                placeholder='Search'
                                type='search'
                                value={search}
                                onChange={(e) => handleSearch(e.target.value)}
                                className={classes.comInput}
                                variant={'standard'}
                                fullWidth
                                id={idNamingConversion('Search', 'customerProductsLine', 'TextField')}
                                onFocus={() => setIconAnimation(true)}
                                onBlur={() => setIconAnimation(false)}
                            />
                            <Image src={SearchIcon} preview={false} />
                            {
                                search && <NavLink to="#" onClick={() => handleSearch('')} className={classes.searchClear}>
                                    <Image
                                        src={ClearIcon}
                                        preview={false}
                                    />
                                </NavLink>
                            }
                        </div>
                    }
                </Col>
                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24}
                    className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                    <div className={classes.vertiCalScrollOverFlow}>
                        <Space size={[20, 20]} direction="horizontal" align="center">
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Products', 'Page', 'Export') &&
                                <NavLink to={'#'}
                                    id={idNamingConversion('Export', 'customerProductsLine', 'Link')}
                                    onClick={() => loadImportExportData('CustomerProductsLines')} className={clsx(classes.customLink, classes.disInline)}>
                                    <Image
                                        src={ExportIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                </NavLink>
                            }
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Products', 'Page', 'Add Lines') && <>
                                    {
                                        form?.customerId && !headerView &&
                                        <NavLink to={'#'}
                                            id={idNamingConversion('Add Line', 'customerProductsLine', 'Link')}
                                            onClick={() => setProductVisible(!productVisible)} className={clsx(classes.customLink, classes.disInline)}>
                                            <Image
                                                src={AddIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Line</span>
                                        </NavLink>
                                    }
                                </>
                            }
                        </Space>
                    </div>
                </Col>
            </Row>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    heads={customerProductLineHead}
                    width={true}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                    component={
                        <LineTable
                            productLineHead={customerProductLineHead}
                            {...props}
                            onEdit={(d, i, v) => onEdit(d, i, v)}
                        />
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <LineForm
                        {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        lineId={lineId !== '' ? lineId + 1 : lines.length + 1}
                        headerView={headerView}
                        handleAddMore={(e) => handleAddMore(e)}
                        lineError={lineError}
                        handleEdit={(v) => { setView(v); setTitle('Edit') }}
                        unitMesurementdetails={unitMesurementdetails}
                        handleProductPrice={(key) => handleProductPrice(key)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        handleProductChange={(data) => handleProductChange(data)}
                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                        onEdit={(d, i, v) => onEdit(d, i, v)}
                    />
                }
            />
            {
                productVisible && <CustomerProducts
                    classes={classes}
                    clsx={clsx}
                    dispatch={dispatch}
                    handleClose={() => setProductVisible(false)}
                    visible={productVisible}
                    handleMyProductsLoad={() => handleMyProductsLoad(true)}
                    customerId={form?.customerId}
                    lineSubmit={(selected) => handleBulkLineSubmit(selected)}
                    lines={lines}
                    hsnApi={() => { }}
                    viewType={'myProducts'}
                    unitMesurementdetails={unitMesurementdetails}
                    customObject={(details, id) => customObject(details, id)}
                    locationApi={() => { }}
                />
            }
        </>
    )
})